export default __webpack_public_path__ + "static/media/share-screen-on.4c69fcb9.svg";